<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">行程信息</span>
            </a-col>
          </a-row>
          <a-tabs
            v-model="activeKey"
            type="editable-card"
            @edit="onEditTabs"
            @tabClick="onTabClick"
            :hideAdd="true"
            style="margin-top: 20px">
            <a-tab-pane v-for="tab in tabList" :tab="tab.title" :key="tab.key" :closable="tab.closable">
            </a-tab-pane>
            <span slot="tabBarExtraContent">
                 <a-button type="primary" @click="addTab(0)">添加行程</a-button>
                <a-button type="primary" @click="addTab(1)" style="margin-left: 20px">复制行程</a-button>
              </span>
          </a-tabs>
          <!--表头信息-->
          <a-form-model
            :label-col="inputItemLayout.labelCol"
            :wrapper-col="inputItemLayout.wrapperCol"
            ref="form"
            :model="packageForm"
            :rules="packageRules"
          >
            <a-form-model-item
              label="行程名称"
              prop="teamRouteName">
              <a-input
                v-model="packageForm.teamRouteName"
                placeholder="请输入行程名称"
                style="max-width: 500px"></a-input>
            </a-form-model-item>
            <a-form-model-item label="成团人数" prop="groupMinNum">
              <a-input-number
                v-model="packageForm.groupMinNum"
                style="width: 200px"
                :min="1"
                :max="10000"
                placeholder="请输入成团人数"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="出发地" prop="teamRouteDepartureCityId">
              <a-radio-group v-model="packageForm.teamRouteDepartureCityId" @change="changeDepartureCity">
                <a-radio v-for="cityItem in proDepartureVoList" :key="cityItem.departureCityId"
                         :value="cityItem.departureCityId">{{ cityItem.departureCityName }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              label="成团地点"
              :required="true"
            >
              <a-form-model-item
                style="display: inline-block;max-width: 500px;margin-bottom: 0"
                prop="teamRoutePartSite">
                <a-select
                  style="width: 200px"
                  @change="teamRoutePartSiteChange"
                  v-model="packageForm.teamRoutePartSite"
                  placeholder="请选择成团方式" clearable>
                  <a-select-option :value="1">出发地成团</a-select-option>
                  <a-select-option :value="2">目的地成团</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                v-if="packageForm.teamRoutePartSite===2||packageForm.teamRoutePartSite===1"
                style="display: inline-block;max-width: 200px;margin-left: 100px;margin-bottom: 0"
                prop="teamRoutePartCityId">
                <a-select
                  v-if="packageForm.teamRoutePartSite===2"
                  style="width: 200px"
                  @change="onDestinationChange"
                  v-model="packageForm.teamRoutePartCityId"
                  placeholder="请选择" clearable>
                  <a-select-option v-for="(item,index) in proDestinationVoList" :value="item.destinationCityId"
                                   :key="item.destinationCityId">
                    {{ item.destinationCityName }}
                  </a-select-option>
                </a-select>
                <a-select
                  v-else-if="packageForm.teamRoutePartSite===1"
                  style="width: 200px"
                  v-model="packageForm.teamRoutePartCityId"
                  :disabled="true"
                  placeholder="请选择" clearable>
                  <a-select-option v-for="(item,index) in proDepartureVoList" :value="item.departureCityId"
                                   :key="item.departureCityId">
                    {{ item.departureCityName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

            </a-form-model-item>
            <a-form-model-item
              :colon="true"
              label="行程天数"
              :required="true"
            >
              <a-form-model-item
                style="display:inline-block;width: 250px;margin-bottom: 0"
                prop="teamRouteDay">
                <a-input-number
                  v-model="packageForm.teamRouteDay"
                  style="width: 200px"
                  placeholder="请输入"
                  :min="1"
                  :max="50"></a-input-number>
                天
              </a-form-model-item>
              <a-form-model-item
                label=""
                style="display:inline-block;margin-left: 50px;margin-bottom: 0"
                prop="teamRouteNight">
                <a-input-number
                  v-model="packageForm.teamRouteNight"
                  style="width: 200px"
                  placeholder="请输入"
                  :min="0"
                  :max="50"></a-input-number>
                晚
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item
              :colon="true"
              label="去程交通"
              :required="true"
            >
              <a-form-model-item
                style="display:inline-block;width: 200px;margin-bottom: 0"
                prop="teamRouteGoTraffic">
                <a-select
                  style="width: 200px"
                  v-model="packageForm.teamRouteGoTraffic"
                  placeholder="请选择" clearable>
                  <a-select-option v-for="(item,index) in trafficList" :value="item.code" :key="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <span style="margin-left: 40px">回程交通: </span>
              <a-form-model-item
                style="display:inline-block;width: 200px;margin-bottom: 0"
                prop="teamRouteBackTraffic">
                <a-select
                  style="width: 100%;max-width: 200px"
                  v-model="packageForm.teamRouteBackTraffic"
                  placeholder="请选择" clearable>
                  <a-select-option v-for="(item,index) in trafficList" :value="item.code" :key="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item
              label=" 集合地点"
              :required="false"
            >
              <a-table
                row-key="rowKey"
                ref="table"
                :dataSource="packageForm.proTeamRouteMusterDtoList"
                :columns="getTabColumns()"
                :pagination="false"
              >
                <template slot="action" slot-scope="text,record,index">
                  <a-button type="danger" @click="removeAddress(record,index)" style="margin-bottom: 24px">删除
                  </a-button>
                </template>
                <a-form-model-item
                  slot="teamMusterTime"
                  slot-scope="text,record,index"
                >
                  <a-time-picker
                    :value="getPickerTime(text)"
                    @change="(m,timeStr)=>onPickerTimeChange(m,timeStr,record,index)"
                    format="HH:mm"
                    style="width: 100%;"
                    placeholder="请选择时间"/>
                </a-form-model-item>
                <template v-for="(itemKey,itemIndex) in inputKeys" :slot="itemKey" slot-scope="text,record,index">
                  <a-form-model-item
                    :key="itemKey"
                  >
                    <a-input
                      v-model="record[itemKey]"
                      placeholder="请输入"
                      style="width: 100%;"
                    />
                  </a-form-model-item>
                </template>
              </a-table>
              <a-button style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus"
                        @click="addAddress">新增
              </a-button>
            </a-form-model-item>
            <div style="width: 100%;">
              <a-tabs :default-active-key="1">
                <a-tab-pane v-for="(dayItem,dayIndex) in packageForm.proTeamRouteDayPlanDtoList" :key="dayIndex"
                            :tab="'第'+(dayIndex+1)+'天'" :closable='false'>
                  <a-form-model-item
                    :colon="true"
                    label="途径路线"
                    :required="true"
                  >
                    <a-form-model-item
                      style="display:inline-block;width: 200px;margin-bottom: 0"
                    >
                      <a-select
                        style="width: 200px"
                        v-model="dayItem.teamDayPlanTraffic"
                        placeholder="请选择" clearable>
                        <a-select-option v-for="(item,index) in trafficList" :value="item.code" :key="item.code">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <span style="margin-left: 40px;margin-right: 40px">到</span>
                    <a-form-model-item
                      style="display:inline-block;width: 200px;margin-bottom: 0"
                    >
                      <a-input
                        style="width: 100%;max-width: 200px"
                        v-model="dayItem.teamDayPlanDestination"
                        placeholder="请输入目的地" clearable>
                      </a-input>
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    :colon="true"
                    label="含餐信息"
                    :required="true"
                    style="margin-bottom: 6px"
                  >
                    如不含早/中/晚餐，则不选中即可，页面会展示为：[早餐：自理]
                  </a-form-model-item>
                  <a-form-model-item
                    label="  "
                    :colon="false"
                    :required="false"
                  >
                    <a-checkbox v-model="dayItem.teamDayPlanHaveBreakfast">含早餐</a-checkbox>
                    <a-form-model-item
                      style="display:inline-block;width: 300px;margin-bottom: 0;margin-left:120px"
                      :validate-status="(dayItem.teamDayPlanHaveBreakfast && dayItem.teamDayPlanBreakfast) || !dayItem.teamDayPlanHaveBreakfast?'success':'error'"
                      :help="(dayItem.teamDayPlanHaveBreakfast&&dayItem.teamDayPlanBreakfast)|| !dayItem.teamDayPlanHaveBreakfast?'':'请输入'"
                    >
                      <a-input
                        v-model="dayItem.teamDayPlanBreakfast"
                        :disabled="!dayItem.teamDayPlanHaveBreakfast"
                        placeholder="可填写餐标、特色餐饮名称"
                        :max-length="20" style="width: 100%"></a-input>
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    label="  "
                    :colon="false"
                    :required="false"
                  >
                    <a-checkbox v-model="dayItem.teamDayPlanHaveLunch">含午餐</a-checkbox>
                    <a-form-model-item
                      style="display:inline-block;width: 300px;margin-bottom: 0;margin-left:120px"
                      :validate-status="(dayItem.teamDayPlanHaveLunch && dayItem.teamDayPlanLunch) || !dayItem.teamDayPlanHaveLunch?'success':'error'"
                      :help="(dayItem.teamDayPlanHaveLunch&&dayItem.teamDayPlanLunch)|| !dayItem.teamDayPlanHaveLunch?'':'请输入'"
                    >
                      <a-input
                        v-model="dayItem.teamDayPlanLunch"
                        :disabled="!dayItem.teamDayPlanHaveLunch"
                        placeholder="可填写餐标、特色餐饮名称"
                        :max-length="20" style="width: 100%"></a-input>
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    label="  "
                    :colon="false"
                    :required="false"
                  >
                    <a-checkbox v-model="dayItem.teamDayPlanHaveDinner">含晚餐</a-checkbox>
                    <a-form-model-item
                      style="display:inline-block;width: 300px;margin-bottom: 0;margin-left:120px"
                      :validate-status="(dayItem.teamDayPlanHaveDinner && dayItem.teamDayPlanDinner) || !dayItem.teamDayPlanHaveDinner?'success':'error'"
                      :help="(dayItem.teamDayPlanHaveDinner&&dayItem.teamDayPlanDinner)|| !dayItem.teamDayPlanHaveDinner?'':'请输入'"
                    >
                      <a-input
                        v-model="dayItem.teamDayPlanDinner"
                        :disabled="!dayItem.teamDayPlanHaveDinner"
                        placeholder="可填写餐标、特色餐饮名称"
                        :max-length="20" style="width: 100%"></a-input>
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    :colon="true"
                    label="住宿信息"
                    :required="true"
                    :validate-status="dayItem.teamDayPlanHaveHotel===0|| dayItem.teamDayPlanHaveHotel===1?'success':'error'"
                    :help="dayItem.teamDayPlanHaveHotel===0|| dayItem.teamDayPlanHaveHotel===1?'':'请选择'"
                  >
                    <a-select
                      style="width: 200px"
                      v-model="dayItem.teamDayPlanHaveHotel"
                      placeholder="请选择" clearable>
                      <a-select-option :value="0">住宿自理</a-select-option>
                      <a-select-option :value="1">包含酒店</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item
                    v-if="dayItem.teamDayPlanHaveHotel==1"
                    :colon="true"
                    label="入住酒店"
                    :required="true"
                    :validate-status="dayItem.teamDayPlanHotel?'success':'error'"
                    :help="dayItem.teamDayPlanHotel?'':'请输入酒店名称'"
                  >
                    <a-input
                      v-model="dayItem.teamDayPlanHotel"
                      style="width: 300px"
                      placeholder="请输入酒店名称"></a-input>
                  </a-form-model-item>
                  <a-card title="时间段信息"
                          :bordered="false"
                          :body-style="{padding:0}">
                    <div v-for="(dayTimeItem,dayTimeIndex) in dayItem.proTeamRouteDayDanDtoList" :key="dayTimeIndex">
                      <p style="padding-left: 24px;padding-top: 20px">
                        <span>时间段{{ dayTimeIndex + 1 }}</span>
                        <a-button type="danger" @click="" style="float: right"
                                  @click="deleteTimeInfo(dayItem,dayTimeItem,dayTimeIndex)">删除时间段
                        </a-button>
                        <a-button type="primary" @click="" style="float: right;margin-right: 20px"
                                  @click="addTimeInfo(dayItem)">新增时间段
                        </a-button>
                      </p>
                      <a-form-model-item
                        label="行程时间段"
                        :required="false"
                      >
                        <a-form-model-item
                          style="display:inline-block;width: 240px;margin-bottom: 0"
                        >
                          <a-time-picker
                            :value=" getPickerTime(dayTimeItem.teamDayDanStartTime)"
                            @change="(m,timeStr)=>onTeamDayDanStartTimeChange(m,timeStr,dayTimeItem)"
                            style="width: 200px"
                            placeholder="请选择"
                            format="HH:mm"
                          ></a-time-picker>
                        </a-form-model-item>
                        <a-form-model-item
                          label=""
                          style="display:inline-block;margin-bottom: 0"
                        >
                          <span style="margin-right: 40px">到</span>
                          <a-time-picker
                            :value=" getPickerTime(dayTimeItem.teamDayDanEndTime)"
                            @change="(m,timeStr)=>onTeamDayDanEndTimeChange(m,timeStr,dayTimeItem)"
                            style="width: 200px"
                            placeholder="请选择"
                            format="HH:mm"
                          ></a-time-picker>
                        </a-form-model-item>
                      </a-form-model-item>
                      <a-form-model-item
                        label="行程描述"
                        :colon="true"
                        :required="false"
                      >
                        <span style="color: red">如果上传本地图片，图片大小应小于1M，图片格式为.jpg .png</span>
                        <a-form-model-item>
                          <vue-ueditor-wrap v-model="dayTimeItem.teamDayDanDes" :config="ueditorConfig"
                                            :destroy="false"></vue-ueditor-wrap>
                        </a-form-model-item>
                      </a-form-model-item>
                    </div>

                  </a-card>
                </a-tab-pane>
              </a-tabs>
            </div>
            <a-card title="费用说明" :bordered="false" :body-style="{padding:0}">
              <a-form-model-item
                style="margin-top: 20px"
                label="费用包含"
                :colon="true"
                :required="false"
                prop="teamRouteFeeContain">
                <a-textarea
                  v-model="packageForm.teamRouteFeeContain"
                  :rows="4"
                  placeholder="请输入"
                  :max-length="5000"></a-textarea>
              </a-form-model-item>
              <a-form-model-item
                label="费用不包含"
                :colon="true"
                :required="false"
                prop="teamRouteFeeNotContain">
                <a-textarea
                  v-model="packageForm.teamRouteFeeNotContain"
                  :rows="4"
                  placeholder="请输入"
                  :max-length="5000"></a-textarea>
              </a-form-model-item>
              <a-form-model-item
                label="预订须知"
                :colon="true"
                :required="false"
                prop="teamRouteNotice">
                <vue-ueditor-wrap v-model="packageForm.teamRouteNotice" :config="ueditorConfig"
                                  :destroy="false"></vue-ueditor-wrap>
              </a-form-model-item>
            </a-card>
            <a-form-model-item
              label="  "
              :colon="false"
              :required="false"
            >
              <a-button @click="backEvent()" style="width: 200px;margin-right: 20px">上一步</a-button>
              <a-button :disabled="proSource!=0" type="primary" @click="submitEvent" style="width: 200px">保存并下一步
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ueditorMixins from '@/utils/mixins/ueditorMixins'
import moment from 'moment'

let tabItem = {
  title: '默认行程',
  key: 0,
  closable: false
}
export default {
  name: 'ItineraryInformation',
  components: {
    ProductHeader,
    PublishHelper
  },
  props: {},
  mixins: [ueditorMixins],
  data() {
    return {
      activeKey: 0,
      proId: '',
      catalogId: '',
      proSource: '',
      tabList: [],
      packageForm: {},
      packageRules: {
        teamRouteName: [
          { required: true, message: '请输入行程名称', trigger: ['blur', 'change'] }
        ],
        teamRouteDepartureCityId: [
          { required: true, message: '请选择出发城市', trigger: ['blur', 'change'] }
        ],
        teamRoutePartSite: [
          { required: true, message: '请选择成团方式', trigger: ['blur', 'change'] }
        ],
        groupMinNum: [
          { required: true, message: '请输入成团人数', trigger: ['blur', 'change'] }
        ],
        teamRoutePartCityId: [
          { required: true, message: '请选择成团地点', trigger: ['blur', 'change'] }
        ],
        teamRouteDay: [
          { required: true, message: '请输入行程天数', trigger: ['blur', 'change'] }
        ],
        teamRouteNight: [
          { required: true, message: '请输入晚数', trigger: ['blur', 'change'] }
        ],
        teamRouteGoTraffic: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        teamRouteBackTraffic: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ],
        teamRouteFeeContain: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        teamRouteFeeNotContain: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        teamRouteNotice: [
          { required: false, message: '请输入', trigger: ['blur', 'change'] }
        ]
      },
      inputItemLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 4 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      proTeamRouteDtoList: [],//行程相关信息
      proDepartureVoList: [],//出发地信息
      proDestinationVoList: [],//目的地信息
      trafficList: [],
      inputKeys: ['teamMusterClumpName', 'teamMusterBackName', 'teamMusterRemarks']
    }
  },
  watch: {
    'packageForm.teamRouteName': function(newVal, oldVal) {
      let tabList = [...this.tabList]
      const currentTabIndex = tabList.findIndex(item => item.key === this.activeKey)
      if (currentTabIndex >= 0) {
        tabList[currentTabIndex].title = newVal ? newVal : '默认行程'
        this.tabList = tabList
      }
    },
    'packageForm.teamRouteDay': function(newVal, oldVal) {
      const length = this.packageForm.proTeamRouteDayPlanDtoList.length
      let currentNum = newVal > 50 ? 50 : newVal
      let addCount = currentNum - length
      if (addCount >= 0) {
        //追加
        for (let i = 0; i < addCount; i++) {
          this.packageForm.proTeamRouteDayPlanDtoList.push({ proTeamRouteDayDanDtoList: [{}] })
        }
      } else {
        //减少
        this.packageForm.proTeamRouteDayPlanDtoList = this.packageForm.proTeamRouteDayPlanDtoList.slice(0, newVal)
      }
    }
  },

  created() {
    this.trafficList = this.getAppConstants().getTrafficList()
    this.tabList.push({ ...tabItem })
    this.packageForm = this.getEmptyForm()
  },
  mounted() {
    let pageParams = this.getPageParams()
    this.proId = pageParams.proId
    this.catalogId = pageParams.catalogId
    this.proSource = pageParams.proSource
    this.getDetails(this.proId)
  },
  methods: {
    getDetails(proId) {
      if (proId && proId !== '0') {
        let path = '/product/team/getProTeamRoute/' + proId
        this.getHttpServices().getProService().post(path)
          .then(details => {
            this.getLogUtils().errorWithTag('========details=======', details)
            this.proDestinationVoList = details.proDestinationVoList
            this.proDepartureVoList = details.proDepartureVoList
            if (details.proTeamRouteDtoList && details.proTeamRouteDtoList.length > 0) {
              //构建tabList
              let tabList = []
              // let rowKey = 'rowKey' + (Math.random() * 1000).toFixed(0) + '_' + new Date().getTime()
              details.proTeamRouteDtoList.forEach((proItem, index, arr) => {
                //补全行程时段信息
                proItem.proTeamRouteDayPlanDtoList.forEach(item => {
                  if (!item.proTeamRouteDayDanDtoList || item.proTeamRouteDayDanDtoList.length < 1) {
                    item.proTeamRouteDayDanDtoList = [{ teamDayDanDes: '' }]
                  }
                })
                proItem.proTeamRouteMusterDtoList.forEach(item => {
                  item.rowKey = this.getKey()//添加唯一ID
                })
                let tabItem = { ...tabItem }
                tabItem.title = proItem.teamRouteName
                tabItem.key = this.getKey()
                tabList.push(tabItem)
              })
              this.tabList = [...tabList]
              this.activeKey = tabList[0].key
              this.$nextTick(() => {
                this.packageForm = details.proTeamRouteDtoList[0]
              })
              this.proTeamRouteDtoList = details.proTeamRouteDtoList
            } else {
              this.tabList = [tabItem]
              this.packageForm = this.getEmptyForm()
              this.proTeamRouteMusterDtoList = [this.getEmptyForm()]
            }
            this.getLogUtils().logWithTag('getProTeamRoute', details)
          }).catch(reason => {
          this.getLogUtils().errorWithTag('getProTeamRoute', reason)
          this.showNetWorkErrorMessage(reason)
        })
      }
    },
    onTabClick(targetKey) {
      const oldKey = this.activeKey
      this.validateCurrentFromParams()
        .then(res => {
          let currentIndex = this.tabList.findIndex(item => oldKey === item.key)
          this.proTeamRouteDtoList[currentIndex] = JSON.parse(JSON.stringify(this.packageForm))//保存当前数据
          let targetIndex = this.tabList.findIndex(item => targetKey === item.key)//要切换的下标
          this.packageForm = JSON.parse(JSON.stringify(this.proTeamRouteDtoList[targetIndex]))
          this.activeKey = targetKey
        }).catch(reason => {
        this.getLogUtils().errorWithTag('validateCurrentFromParams', reason)
        this.$message.error('请先完善当前行程信息')
        setTimeout(() => this.activeKey = oldKey, 300)
      })
    },
    onEditTabs(targetKey, action) {
      if (action === 'remove') {
        this.removeTab(targetKey)
      } else if (action === 'add') {
        this.addTab()
      }
    },
    //type===1标识拷贝（复制）
    addTab(type) {
      if (this.tabList.length === 5) {
        this.$message.warn('最多只能添加5个行程')
      } else {
        this.validateCurrentFromParams()
          .then(res => {
            let newTabItem = { ...tabItem }
            newTabItem.title = type === 1 ? '复制行程' : '新增行程'
            newTabItem.key = this.getKey()
            newTabItem.closable = true
            let currentIndex = this.tabList.findIndex(item => this.activeKey === item.key)
            this.proTeamRouteDtoList[currentIndex] = JSON.parse(JSON.stringify(this.packageForm))//保存当前数据
            if (type !== 1) {
              this.packageForm = this.getEmptyForm()//新增，要把当前数据置空
              this.proTeamRouteDtoList.push(this.getEmptyForm())
            } else {
              //将当前数据复制到列表中
              const copyForm = JSON.parse(JSON.stringify(this.packageForm))
              copyForm.teamRouteId = ''//重置行程ID
              copyForm.isCopy = 1
              this.proTeamRouteDtoList.push(copyForm)
              this.packageForm = { ...copyForm }
            }
            this.tabList = [...this.tabList, newTabItem]
            this.activeKey = newTabItem.key
          }).catch(reason => {
          this.getLogUtils().errorWithTag('validateCurrentFromParams', reason)
          this.$message.success('请先完善当前行程信息')
        })
      }
    },

    removeTab(targetKey) {
      if (this.tabList.length < 2) {
        this.$message.error('至少要保留一个行程')
        return
      }
      const filterList = this.tabList.filter(pane => pane.key !== targetKey)
      let removeIndex = this.tabList.findIndex(pane => pane.key === targetKey)//要删除的项
      let filterProTeamRouteDtoList = [...this.proTeamRouteDtoList].filter((item, index, arr) => index !== removeIndex)
      let activeIndex = filterList.length - 1
      let newActiveKey = filterList[activeIndex].key
      this.activeKey = newActiveKey
      this.tabList = [...filterList]
      this.packageForm = JSON.parse(JSON.stringify(filterProTeamRouteDtoList[activeIndex]))
      this.proTeamRouteDtoList = filterProTeamRouteDtoList
    },
    changeDepartureCity(value) {
      let findItem = this.proDepartureVoList.find(item => this.packageForm.teamRouteDepartureCityId === item.departureCityId)
      this.packageForm.teamRouteDepartureCityName = findItem ? findItem.departureCityName : undefined
      if (this.packageForm.teamRoutePartSite === 1) {
        this.packageForm.teamRoutePartCityId = this.packageForm.teamRouteDepartureCityId
        this.packageForm.teamRoutePartCityName = this.packageForm.teamRouteDepartureCityName
      }
    },
    //成团方式变更监听
    teamRoutePartSiteChange(value) {
      if (value === 1) {
        this.packageForm.teamRoutePartCityId = this.packageForm.teamRouteDepartureCityId
        this.packageForm.teamRoutePartCityName = this.packageForm.teamRouteDepartureCityName
      } else {
        this.packageForm.teamRoutePartCityId = undefined
        this.packageForm.teamRoutePartCityName = undefined
      }
    },
    //目的地成团变更
    onDestinationChange(value) {
      const findItem = this.proDestinationVoList.find(item => value === item.destinationCityId)
      this.packageForm.teamRoutePartCityName = findItem ? findItem.destinationCityName : undefined
    },
    addAddress() {
      let rowKey = this.getKey()
      let teamMusterRemarks = '以出团通知书为准'//默认备注
      this.packageForm.proTeamRouteMusterDtoList.push({ rowKey: rowKey, teamMusterRemarks: teamMusterRemarks })
    },

    removeAddress(record, removeIndex) {
      this.packageForm.proTeamRouteMusterDtoList = this.packageForm.proTeamRouteMusterDtoList.filter((item, index, arr) => removeIndex !== index)
    },
    getPickerTime(teamMusterTime) {
      return teamMusterTime ? moment(teamMusterTime, 'HH:mm') : undefined
    },
    onPickerTimeChange(m, timeStr, record, index) {
      this.packageForm.proTeamRouteMusterDtoList[index].teamMusterTime = timeStr
      this.packageForm.proTeamRouteMusterDtoList = [...this.packageForm.proTeamRouteMusterDtoList]
    },

    onTeamDayDanStartTimeChange(m, timeStr, dayTimeItem) {
      dayTimeItem.teamDayDanStartTime = timeStr
      this.packageForm = { ...this.packageForm }
    },
    onTeamDayDanEndTimeChange(m, timeStr, dayTimeItem) {
      dayTimeItem.teamDayDanEndTime = timeStr
      this.packageForm = { ...this.packageForm }
    },
    deleteTimeInfo(dayItem, dayTimeItem, dayTimeIndex) {
      if (dayItem.proTeamRouteDayDanDtoList.length === 1) {
        this.$message.error('至少需要一个行程时间段')
        return
      }
      dayItem.proTeamRouteDayDanDtoList = dayItem.proTeamRouteDayDanDtoList.filter((item, index, arr) => index !== dayTimeIndex)
    },
    addTimeInfo(dayItem) {
      dayItem.proTeamRouteDayDanDtoList.push({ teamDayDanDes: '' })
    },
    submitEvent() {
      this.validateCurrentFromParams()
        .then(res => {
          this.requestSubmit()
        }).catch(reason => {
        if (reason) {
          this.$message.error(reason)
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },
    requestSubmit() {
      let currentIndex = this.tabList.findIndex(item => this.activeKey === item.key)
      this.proTeamRouteDtoList[currentIndex] = JSON.parse(JSON.stringify(this.packageForm))  //更新当前tab信息
      //删除集合地点的key
      let proTeamRouteDtoList = JSON.parse(JSON.stringify(this.proTeamRouteDtoList))
      proTeamRouteDtoList.forEach(proItem => {
        proItem.proTeamRouteMusterDtoList.forEach(item => {
          delete item.rowKey
        })
        if (proItem.proTeamRouteDayPlanDtoList && proItem.proTeamRouteDayPlanDtoList.length === 0) {
          proItem.proTeamRouteDayPlanDtoList = [{ proTeamRouteDayDanDtoList: [{}] }]
        }
      })
      let params = {
        teamRouteProId: this.proId,
        proTeamRouteDtoList: proTeamRouteDtoList
      }
      console.error('=======requestSubmit===========', params)
      let path = '/product/team/addOrUpdateProTeamRoute'
      this.getHttpServices().getProService().post(path, params)
        .then(res => {
          this.getLogUtils().logWithTag('addOrUpdateProTeamRoute', res)
          this.$message.success('行程信息更新成功')
          this.onNext()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },

    onNext() {
      this.openNewPage('PresaleSetting', { proId: this.proId, catalogId: this.catalogId, proSource: this.proSource })
    },

    getTabColumns() {
      return [
        {
          title: '集合地点',
          dataIndex: 'teamMusterClumpName',
          scopedSlots: { customRender: 'teamMusterClumpName' }
        },
        {
          title: '集合时间',
          dataIndex: 'teamMusterTime',
          scopedSlots: { customRender: 'teamMusterTime' }
        },
        {
          title: '返回地点',
          dataIndex: 'teamMusterBackName',
          scopedSlots: { customRender: 'teamMusterBackName' }
        },
        {
          title: '备注',
          dataIndex: 'teamMusterRemarks',
          scopedSlots: { customRender: 'teamMusterRemarks' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    //校提交信息
    validateCurrentFromParams() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(valid => {
          if (valid) {
            //校验非标输入信息（自定义）
            let errorTips = this.validateAddressInfo()
            if (errorTips) {
              reject(errorTips)
            } else {
              errorTips = this.validateTeamRouteDayPlan()
              if (errorTips) {
                reject(errorTips)
              } else {
                resolve()
              }
            }
          } else {
            reject()
          }
        })
      })
    },
    //校验地点集合信息
    validateAddressInfo() {
      let proTeamRouteMusterDtoList = this.packageForm.proTeamRouteMusterDtoList
      for (let i = 0, len = proTeamRouteMusterDtoList.length; i < len; i++) {
        let addressInfo = proTeamRouteMusterDtoList[i]
        let keys = Object.keys(addressInfo)
        if (keys.every(key => (key !== 'teamMusterRemarks' && addressInfo[key]) || key !== 'teamMusterRemarks')) {
          return '请完善集合地点信息'
        }
      }
      return ''
    },
    //校验行程天的具体信息
    validateTeamRouteDayPlan() {
      let proTeamRouteDayPlanDtoList = this.packageForm.proTeamRouteDayPlanDtoList
      if (proTeamRouteDayPlanDtoList.length > 0) {
        for (let i = 0, len = proTeamRouteDayPlanDtoList.length; i < len; i++) {
          let item = proTeamRouteDayPlanDtoList[i]
          let tips = '第' + (i + 1) + '天'
          if (!item.teamDayPlanTraffic) {
            return '请选择' + tips + '的途径线路'
          }
          if (!item.teamDayPlanDestination) {
            return '请选择' + tips + '的到达目的地'
          }
          if (item.teamDayPlanHaveBreakfast && !item.teamDayPlanBreakfast) {
            return tips + '的早餐信息'
          }
          if (item.teamDayPlanHaveLunch && !item.teamDayPlanLunch) {
            return tips + '的午餐信息'
          }
          if (item.teamDayPlanHaveDinner && !item.teamDayPlanDinner) {
            return '请输入' + tips + '的晚餐信息'
          }
          if (item.teamDayPlanHaveHotel !== 0 && item.teamDayPlanHaveHotel !== 1) {
            return '请选择' + tips + '的入住信息'
          }
          if (item.teamDayPlanHaveHotel === 1 && !item.teamDayPlanHotel) {
            return '请输入' + tips + '的入住酒店名称'
          }
        }
      }
      return ''
    },
    getEmptyForm() {
      return {
        isCopy: 0,//非复制
        teamRouteBackTraffic: undefined,
        teamRouteDay: 1,
        teamRouteDepartureCityId: undefined,
        teamRouteDepartureCityName: undefined,
        teamRouteFeeContain: undefined,
        teamRouteFeeNotContain: undefined,
        teamRouteGoTraffic: undefined,
        teamRouteId: undefined,
        teamRouteName: '默认行程',
        teamRouteNight: '',
        teamRouteNotice: '',
        teamRoutePartCityId: undefined,
        teamRoutePartCityName: '',
        teamRoutePartSite: undefined,
        proTeamRouteDayPlanDtoList: [{
          proTeamRouteDayDanDtoList: [{ teamDayDanDes: '' }]
        }],
        proTeamRouteMusterDtoList: []//集合点信息
      }
    },

    getKey(prefix) {
      return prefix ? prefix : 'rowKey' + (Math.random() * 100).toFixed(0) + '_' + new Date().getTime() + '_' + (Math.random() * 100)
    }
  }

}
</script>
<style scoped lang="less">
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 900px;
      flex-grow: 1;
    }
  }
}
</style>